import React, { Component } from "react";
import { message, Select, Alert, Space, Spin, InputNumber, Collapse, Row, Col } from "antd";
import { CalculatorOutlined } from "@ant-design/icons";
import axios from "axios";
import { connect } from "react-redux";
import { ButtonItem, TableItem, ModalItem, MensajeError, SelectInsumosItem } from "../../../../Components/Items";
import { iconoDeEtapa, colorDeEtapa } from "../../PresupuestosPU/EtapasOrdenProduccionPU/etapaVisual.utils";
import { minutosAUnidad, unidadAMinutos, etiquetaUnidadTiempo } from "../../PresupuestosPU/OrdenesDeProduccionPU/PlaneacionProduccionPU/planeacion.utils";

const { Option } = Select;

const esEtapaConfigurable = (etapa) => !etapa.esInicial;

const estiloCampo = { width: "100%", border: "1px solid #d9d9d9", borderRadius: 6, background: "#fff" };

const CampoNumero = ({ sufijo, ...props }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    <InputNumber style={estiloCampo} {...props} />
    {sufijo && <span style={{ color: "#595959", whiteSpace: "nowrap" }}>{sufijo}</span>}
  </div>
);

class CalculadoraTiempoCiclo extends Component {
  state = { piezasPorHora: undefined, visible: false };

  tiempoCalculado = () => {
    const { piezasPorHora } = this.state;
    if (!(piezasPorHora > 0)) return undefined;
    return Math.round(minutosAUnidad(60 / piezasPorHora, this.props.unidad) * 10000) / 10000;
  };

  cerrar = () => this.setState({ visible: false, piezasPorHora: undefined });

  usar = () => {
    const tiempo = this.tiempoCalculado();
    if (tiempo === undefined) return;
    this.props.onUsar(tiempo);
    this.cerrar();
  };

  render() {
    const tiempo = this.tiempoCalculado();
    return (
      <>
        <ButtonItem type="default" size="small" blanco icon={<CalculatorOutlined />} onClick={() => this.setState({ visible: true })} />
        <ModalItem title="Calcular tiempo ciclo" visible={this.state.visible} onCancel={this.cerrar} width={380} paddingTop>
          <div style={{ fontWeight: 600, marginBottom: 6 }}>Piezas por hora</div>
          <CampoNumero
            min={0}
            placeholder="Ej. 200"
            sufijo="pzs/h"
            value={this.state.piezasPorHora}
            onChange={(piezasPorHora) => this.setState({ piezasPorHora })}
            onPressEnter={this.usar}
          />
          <div
            style={{
              margin: "16px 0",
              padding: "10px 14px",
              borderRadius: 6,
              background: tiempo !== undefined ? "#e6fffb" : "#fafafa",
              borderLeft: `3px solid ${tiempo !== undefined ? "#00BFD6" : "#d9d9d9"}`,
              color: "#1a3a4a",
            }}
          >
            {tiempo !== undefined ? (
              <>
                <div style={{ fontSize: 12, color: "#595959" }}>Tiempo ciclo por pieza</div>
                <div style={{ fontSize: 20, fontWeight: 700 }}>
                  {tiempo} {etiquetaUnidadTiempo(this.props.unidad)}
                </div>
              </>
            ) : (
              <span style={{ color: "#8c8c8c" }}>Captura las piezas por hora para calcular el tiempo.</span>
            )}
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <ButtonItem onClick={this.cerrar}>Cancelar</ButtonItem>
            <ButtonItem type="primary" disabled={tiempo === undefined} onClick={this.usar}>
              Usar este tiempo
            </ButtonItem>
          </div>
        </ModalItem>
      </>
    );
  }
}

class ProduccionMatriz extends Component {
  state = { loading: false, guardando: false, matriz: null, flujos: [], flujoId: null, etapas: [], filas: {}, defaults: {} };

  componentDidMount() {
    this.cargarFlujos();
    this.cargarMatriz();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.insumoId !== this.props.insumoId && this.props.insumoId) this.cargarMatriz();
  }

  cargarFlujos = () => {
    axios
      .post("flujosProduccionPU/selectTodosFlujos", { empresaId: this.props.empresaId, valor: 1 }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) this.setState({ flujos: res.data.flujos || [] });
      })
      .catch(() => MensajeError({ message: "Error al cargar los flujos de producción" }));
  };

  cargarMatriz = () => {
    if (!this.props.insumoId) return;
    this.setState({ loading: true });
    axios
      .post("matrices/datosProduccionMatriz", { empresaId: this.props.empresaId, insumoId: this.props.insumoId }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          MensajeError({ message: res.data.message || "No se pudo cargar la configuración de producción" });
          return;
        }
        const filas = {};
        (res.data.matriz.produccionEtapas || []).forEach((renglon) => {
          filas[renglon.etapaId] = {
            tiempoCiclo: minutosAUnidad(renglon.tiempoCiclo || 0, this.props.unidadTiempoProduccion) || undefined,
            porcentajeEsperado: renglon.porcentajeEsperado,
            insumosConsumidos: renglon.insumosConsumidos || [],
          };
        });
        this.setState({
          matriz: res.data.matriz,
          flujoId: res.data.matriz.flujoProduccionPUId,
          defaults: res.data.matriz.produccionDefaults || {},
          etapas: (res.data.etapas || []).filter(esEtapaConfigurable),
          filas,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  cambiarFlujo = (flujoId) => {
    this.setState({ flujoId: flujoId || null, etapas: [], filas: {}, loading: !!flujoId });
    if (!flujoId) return;
    axios
      .post("etapasOrdenProduccionPU/selectTodasEtapas", { empresaId: this.props.empresaId, flujoId, valor: 1 }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) this.setState({ etapas: (res.data.etapas || []).filter(esEtapaConfigurable) });
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al cargar las etapas del flujo" });
      });
  };

  cambiarCampo = (etapaId, campo, valor) => {
    this.setState((prev) => ({ filas: { ...prev.filas, [etapaId]: { ...prev.filas[etapaId], [campo]: valor } } }));
  };

  etapaDeInsumo = (insumoId) => {
    const entrada = Object.entries(this.state.filas).find(([, fila]) => (fila.insumosConsumidos || []).includes(insumoId));
    return entrada ? entrada[0] : undefined;
  };

  asignarInsumo = (insumoId, etapaId) => {
    this.setState((prev) => {
      const filas = {};
      Object.entries(prev.filas).forEach(([id, fila]) => {
        filas[id] = { ...fila, insumosConsumidos: (fila.insumosConsumidos || []).filter((i) => i !== insumoId) };
      });
      if (etapaId) {
        filas[etapaId] = { ...filas[etapaId], insumosConsumidos: [...(filas[etapaId]?.insumosConsumidos || []), insumoId] };
      }
      return { filas };
    });
  };

  renderEtapaNombre = (etapa) => (
    <Space>
      <span style={{ color: colorDeEtapa(etapa) }}>{iconoDeEtapa(etapa)}</span>
      {etapa.nombre}
    </Space>
  );

  sumaPorcentajes = (excluirEtapaId) =>
    Math.round(
      Object.entries(this.state.filas).reduce((acc, [id, fila]) => (id === excluirEtapaId ? acc : acc + (Number(fila.porcentajeEsperado) || 0)), 0) * 100
    ) / 100;

  hayPorcentajes = () => Object.values(this.state.filas).some((fila) => fila.porcentajeEsperado !== undefined && fila.porcentajeEsperado !== null);

  cambiarDefault = (campo, valor) => this.setState((prev) => ({ defaults: { ...prev.defaults, [campo]: valor || undefined } }));

  guardar = () => {
    const { flujoId, filas, etapas, defaults } = this.state;
    if (this.hayPorcentajes() && this.sumaPorcentajes() !== 100) {
      MensajeError({ message: `Los porcentajes esperados deben sumar 100% (suman ${this.sumaPorcentajes()}%).` });
      return;
    }
    const unidad = this.props.unidadTiempoProduccion;
    const produccionEtapas = etapas.map((etapa) => {
      const fila = filas[etapa._id] || {};
      return {
        etapaId: etapa._id,
        tiempoCiclo: fila.tiempoCiclo && !etapa.esFinal ? unidadAMinutos(fila.tiempoCiclo, unidad) : 0,
        porcentajeEsperado: fila.porcentajeEsperado,
        insumosConsumidos: fila.insumosConsumidos || [],
      };
    });

    this.setState({ guardando: true });
    axios
      .post(
        "matrices/actualizarProduccionMatriz",
        { empresaId: this.props.empresaId, insumoId: this.props.insumoId, flujoProduccionPUId: flujoId, produccionEtapas, produccionDefaults: defaults },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ guardando: false });
        if (res.data.success === 2) {
          message.success("Configuración de producción guardada");
          this.props.onGuardado && this.props.onGuardado();
        } else {
          MensajeError({ message: res.data.message || "No se pudo guardar la configuración" });
        }
      })
      .catch(() => {
        this.setState({ guardando: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  render() {
    const { flujos, flujoId, etapas, filas, matriz, defaults } = this.state;
    const unidad = this.props.unidadTiempoProduccion;

    const columnasInsumos = [
      {
        title: "Insumo",
        key: "insumo",
        render: (_, c) => `${c.clave ? c.clave + " - " : ""}${c.descripcion || ""}`,
      },
      { title: "Cantidad", dataIndex: "cantidad", key: "cantidad", align: "right", width: 120 },
      {
        title: "Se consume en la etapa",
        key: "etapa",
        width: "40%",
        render: (_, c) => (
          <Select
            allowClear
            style={{ width: "100%" }}
            placeholder="Primera etapa productiva (por defecto)"
            value={this.etapaDeInsumo(c.insumoId)}
            onChange={(etapaId) => this.asignarInsumo(c.insumoId, etapaId)}
          >
            {etapas.filter((etapa) => !etapa.esFinal).map((etapa) => (
              <Option key={etapa._id} value={etapa._id}>
                {this.renderEtapaNombre(etapa)}
              </Option>
            ))}
          </Select>
        ),
      },
    ];

    const columns = [
      {
        title: "Etapa",
        dataIndex: "nombre",
        key: "nombre",
        width: "30%",
        render: (nombre, etapa) => this.renderEtapaNombre(etapa),
      },
      {
        title: `Tiempo ciclo (${etiquetaUnidadTiempo(unidad)} por pieza)`,
        key: "tiempoCiclo",
        width: "35%",
        render: (_, etapa) => etapa.esFinal ? (
          <span style={{ color: "#8c8c8c" }}>—</span>
        ) : (
          <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
            <CampoNumero
              min={0}
              placeholder="Sin tiempo"
              sufijo={`${etiquetaUnidadTiempo(unidad)}/pza`}
              value={filas[etapa._id]?.tiempoCiclo}
              onChange={(valor) => this.cambiarCampo(etapa._id, "tiempoCiclo", valor)}
            />
            <CalculadoraTiempoCiclo unidad={unidad} onUsar={(valor) => this.cambiarCampo(etapa._id, "tiempoCiclo", valor)} />
          </div>
        ),
      },
      {
        title: "% esperado",
        key: "porcentajeEsperado",
        width: "35%",
        render: (_, etapa) => (
          <CampoNumero
            min={0}
            max={Math.max(0, Math.round((100 - this.sumaPorcentajes(etapa._id)) * 100) / 100)}
            placeholder="Sin porcentaje"
            sufijo="%"
            value={filas[etapa._id]?.porcentajeEsperado}
            onChange={(valor) => this.cambiarCampo(etapa._id, "porcentajeEsperado", valor)}
          />
        ),
      },
    ];

    return (
      <Spin spinning={this.state.loading || this.state.guardando}>
        <div style={{ marginBottom: 12, display: "flex", alignItems: "center", gap: 12 }}>
          <strong>Flujo de producción</strong>
          <Select
            showSearch
            allowClear
            style={{ minWidth: 300 }}
            placeholder="Selecciona el flujo"
            optionFilterProp="children"
            value={flujoId || undefined}
            onChange={this.cambiarFlujo}
          >
            {flujos.map((flujo) => (
              <Option key={flujo._id} value={flujo._id}>
                {flujo.nombre}
              </Option>
            ))}
          </Select>
        </div>

        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 12 }}
          message="El tiempo ciclo es opcional: la última etapa con tiempo marca hasta dónde se cuenta el tiempo y el atraso en el dashboard. El % esperado es el porcentaje de piezas que se acepta que lleguen a esa etapa. Cada insumo se asigna a la etapa donde se consume; si no lo asignas, se consume en la primera etapa productiva."
        />
        <Collapse ghost style={{ marginBottom: 12 }}>
          <Collapse.Panel header="¿Cómo capturar los % esperados y cómo se usan en los reportes?" key="ayuda">
            <ul style={{ paddingLeft: 18, margin: 0, color: "#1a3a4a" }}>
              <li>Pon % esperado solo en las etapas de <b>resultado</b>: la final (OK / Terminado) y las de piezas malas (re-proceso o pulido, retrabajo, scrap). Las etapas de proceso (producción, calidad, ensamble) van sin porcentaje.</li>
              <li>Los porcentajes que captures deben sumar <b>100%</b>. Ejemplo: OK 90%, Re-proceso 10%, Retrabajo 0%, Scrap 0%.</li>
              <li>Cada etapa se evalúa según su <b>tipo de objetivo</b> (se configura en la etapa del flujo): <b>Mínimo</b> cumple si llegan al menos ese % (OK) y <b>Máximo</b> cumple si no se pasa de ese % (re-proceso, retrabajo, scrap). Sin configurar, la etapa final es mínimo y las demás máximo.</li>
              <li><b>Producción real</b> del reporte = piezas que hoy están en las etapas con % esperado (OK + re-proceso + retrabajo + scrap). Cada pieza cuenta una vez, donde está ahora; los % del reporte se calculan sobre ese total.</li>
              <li><b>First Time Quality</b> = cada pieza original cuenta una sola vez en el <b>primer</b> resultado al que llegó, aunque después se mueva (si va a re-proceso y luego a OK, en FTQ sigue siendo re-proceso).</li>
              <li>La etapa marcada como <b>retrabajo</b> en el flujo manda las piezas a una orden de retrabajo con su matriz (R); en la orden original se siguen viendo, en color opaco, con la OP a la que se fueron.</li>
            </ul>
          </Collapse.Panel>
        </Collapse>

        {flujoId ? (
          <>
            <TableItem size="small" pagination={false} dataSource={etapas} columns={columns} rowKey="_id" />
            <div style={{ fontWeight: 600, margin: "20px 0 8px" }}>Consumo de insumos por etapa</div>
            <TableItem
              size="small"
              pagination={false}
              dataSource={matriz?.componentes || []}
              columns={columnasInsumos}
              rowKey="insumoId"
              locale={{ emptyText: "La matriz no tiene insumos" }}
            />
            <div style={{ fontWeight: 600, margin: "20px 0 4px" }}>Insumos por defecto al mover piezas</div>
            <div style={{ color: "#8c8c8c", fontSize: 12, marginBottom: 8 }}>
              Se ponen solos al mover piezas a Terminado, Scrap o Retrabajo; en cada movimiento se pueden cambiar sin tocar este default.
            </div>
            <Row gutter={16}>
              <Col span={8}>
                <div style={{ marginBottom: 4 }}>Producto terminado</div>
                <SelectInsumosItem
                  tiposInsumos="inventariables"
                  empresaId={this.props.empresaId}
                  headersToken={this.props.headersToken}
                  placeholder="Insumo terminado"
                  allowClear
                  width="100%"
                  value={defaults.insumoTerminadoId || undefined}
                  onChange={(valor) => this.cambiarDefault("insumoTerminadoId", valor)}
                />
              </Col>
              <Col span={8}>
                <div style={{ marginBottom: 4 }}>Scrap</div>
                <SelectInsumosItem
                  tiposInsumos="inventariables"
                  empresaId={this.props.empresaId}
                  headersToken={this.props.headersToken}
                  placeholder="Insumo de scrap"
                  allowClear
                  width="100%"
                  value={defaults.insumoScrapId || undefined}
                  onChange={(valor) => this.cambiarDefault("insumoScrapId", valor)}
                />
              </Col>
              <Col span={8}>
                <div style={{ marginBottom: 4 }}>Matriz de retrabajo</div>
                <SelectInsumosItem
                  tiposInsumos="matrices"
                  empresaId={this.props.empresaId}
                  headersToken={this.props.headersToken}
                  placeholder="Matriz de retrabajo"
                  allowClear
                  width="100%"
                  value={defaults.matrizRetrabajoId || undefined}
                  onChange={(valor) => this.cambiarDefault("matrizRetrabajoId", valor)}
                />
              </Col>
            </Row>
          </>
        ) : (
          <div style={{ color: "#999", padding: 16 }}>Elige un flujo para configurar sus etapas.</div>
        )}

        {flujoId && this.hayPorcentajes() && (
          <div style={{ textAlign: "right", marginTop: 8, fontWeight: 600, color: this.sumaPorcentajes() === 100 ? "#389e0d" : "#d46b08" }}>
            Suma de porcentajes esperados: {this.sumaPorcentajes()}% {this.sumaPorcentajes() === 100 ? "" : `(faltan ${Math.round((100 - this.sumaPorcentajes()) * 100) / 100}%)`}
          </div>
        )}

        {flujoId && (
          <ButtonItem type="primary" onClick={this.guardar} style={{ display: "block", margin: "12px 0 0 auto" }}>
            Guardar producción
          </ButtonItem>
        )}
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  unidadTiempoProduccion: state.empresa.unidadTiempoProduccion,
});

export default connect(mapStateToProps)(ProduccionMatriz);
